module.exports = __webpack_public_path__ + "static/media/tick1.57bff100.svg";